(() => {
    const MODULE = {
        config: {
            fonts: {
                'Script': "'Script Font', sans-serif",
                'Serif': "'Serif Font', sans-serif",
                'Sans': "'Sans Font', sans-serif"
            },
            fontDropdown: null,
            engravingTextarea: null,
            fallbackFont: "'Arial', sans-serif"
        },

        init: function () {
            this.waitForElements(() => {
                this.registerEventHandlers();
                this.applyFontStylesToOptions();
            });
        },

        waitForElements: function (callback) {
            const observer = new MutationObserver(() => {
                this.config.fontDropdown = document.querySelector('select[name^="properties["][name*="Font"]');
                this.config.engravingTextarea = document.querySelector('textarea[name="properties[Engraving Text]"]');

                if (this.config.fontDropdown && this.config.engravingTextarea) {
                    observer.disconnect();
                    callback();
                }
            });

            observer.observe(document.body, { childList: true, subtree: true });
        },

        registerEventHandlers: function () {
            document.addEventListener('giftship.loaded', this.handleGiftshipLoaded.bind(this));
        },

        handleGiftshipLoaded: function () {
            const { fontDropdown, engravingTextarea } = this.config;
            if (!fontDropdown || !engravingTextarea) return;

            this.bindFontDropdownChange();
            this.applyFontStylesToOptions();
            this.updateTextareaFont(fontDropdown.value);
        },

        bindFontDropdownChange: function () {
            const { fontDropdown } = this.config;
            if (fontDropdown) {
                fontDropdown.addEventListener('change', this.debounce(this.handleFontDropdownChange.bind(this), 200));
            }
        },

        handleFontDropdownChange: function () {
            const { fontDropdown } = this.config;
            this.updateTextareaFont(fontDropdown.value);
        },

        updateTextareaFont: function (selectedFont) {
            const { engravingTextarea, fonts, fallbackFont } = this.config;
            const font = fonts[selectedFont] || fallbackFont;
            if (engravingTextarea) {
                engravingTextarea.style.fontFamily = font;
            }
        },

        applyFontStylesToOptions: function () {
            const { fontDropdown, fonts } = this.config;
            if (!fontDropdown) return;

            fontDropdown.querySelectorAll('option').forEach(option => {
                const fontName = option.value.trim();
                if (!fontName || !fonts[fontName]) return;
                option.dataset.fontFamily = fonts[fontName];
            });

            fontDropdown.addEventListener("change", function () {
                const selectedFont = fontDropdown.value.trim();
                if (!selectedFont) return;
                if (MODULE.config.fonts[selectedFont]) {
                    fontDropdown.style.fontFamily = MODULE.config.fonts[selectedFont];
                }
            });

            const style = document.createElement("style");
            style.innerHTML = `
                select[name^="properties["][name*="Font"] option[value="Script"] { font-family: 'Script Font', sans-serif; }
                select[name^="properties["][name*="Font"] option[value="Serif"] { font-family: 'Serif Font', sans-serif; }
                select[name^="properties["][name*="Font"] option[value="Sans"] { font-family: 'Sans Font', sans-serif; }
            `;
            document.head.appendChild(style);
        },

        debounce: function (func, delay) {
            let timer;
            return function (...args) {
                clearTimeout(timer);
                timer = setTimeout(() => func.apply(this, args), delay);
            };
        }
    };

    MODULE.init();
})();
